import { getContactsService, updateContactService, createContactService, deleteContactService, resetContactService } from "@/services/contacts.svc"

const defaultState = () => ({
    contacts: [],
    headers: [
        {
            text: 'Company',
            value: 'Company',
            sortable: true
        },        
        {
            text: 'Full Name',
            value: 'FullName',
            sortable: true
        },
        {
            text: 'Email',
            value: 'Email',
            sortable: false
        },        
        {
            text: 'Phone',
            value: 'Phone',
            sortable: false
        },
        {
            text: 'Actions',
            value: 'actions',
            sortable: false
        }
    ]
})

export default {
    namespaced: true,
    state: defaultState(),

    actions: {
        async setContactsAction({ commit }, showAll = false) {
            const contacts = await getContactsService(showAll)
            commit('SET_CONTACTS', contacts)
        },

        async createContactAction(_, payload) {
            return await createContactService(payload)
        },

        async deleteContactAction(_, payload) {
            return await deleteContactService(payload.ID)
        },

        async updateContactAction(_, payload) {
            return await updateContactService(payload)
        },

        async resetContactAction(_, payload) {
            return await resetContactService(payload.ID)
        }        
    },

    getters: {
        contacts: (state) => state.contacts,
        contactsByCustomerId: (state) => (customerId) => state.contacts
            .filter(c => c.CustomerID === customerId)
            .sort((a,b) => a.FullName.localeCompare(b.FullName)),
        contactsByIds: (state) => (ids) => state.contacts.filter(c => ids.includes(c.ID)),
        headers: (state) => state.headers,
    },

    mutations: {
        SET_CONTACTS(state, payload) {
            state.contacts = payload
        }
    }
}